import { render, staticRenderFns } from "./YA_AboutProducts.vue?vue&type=template&id=c853c106&scoped=true"
import script from "./YA_AboutProducts.vue?vue&type=script&lang=js"
export * from "./YA_AboutProducts.vue?vue&type=script&lang=js"
import style0 from "./YA_AboutProducts.vue?vue&type=style&index=0&id=c853c106&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c853c106",
  null
  
)

export default component.exports